export default class Selectbox {
  element: any;
  methods: {
    orderValueHandler: (param:string) => void;
  };

  constructor(element: any, methods: {orderValueHandler: (param: string) => void }) {
    this.element = element;
    this.methods = methods;
    $(this.element).on('change', (event: any) => {
      this.methods.orderValueHandler(event.target.value);
    })
  }
}
